import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useNavigate } from 'react-router-dom';
import NumberFlow from '@number-flow/react';
import { pathOr } from 'ramda';

// store
import { useStoreValue } from '../../store';

// service
import DashboardService from '../../service/dashboard-service';

// components
import BadgeClassic from '../../components/BadgeClassic';
import ListCompaniesTablePreInstructor
    from '../ManageSuppliersPreInstructor/components/ListCompaniesTablePreInstructor';

const DashboardPreInstructor = () => {
    const navigate = useNavigate();
    const [mainStats, setMainStats] = useState({});

    const goToAllEvaluations = () => {
        navigate('/fornitori');
    }

    const getStats = (data) => {
        if (data.status === 'SUCCESS') {
            setMainStats(data.data);
        }
    }

    const errGetStats = () => {}

    const getStatValue = (keys = [], fallback = '') => {
        return pathOr(fallback, keys, mainStats);
    }

    useEffect(() => {
        DashboardService.getInstructorCompanyStats(getStats, errGetStats);
    }, []);
    console.log('mainStats', mainStats)

    return(
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Dashboard', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection statsBigBadges">
                <h2>{__('Riepilogo', 'htr')}</h2>
                <div className="statsBigBadges__grid grid-small">
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Aziende da valutare', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue(['numberOfAssignedCompany'], 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <div className="meta">
                            <BadgeClassic label={getStatValue(['assignedYesterday'], 0)} value={getStatValue(['assignedYesterday'], 0)}/>
                            {__('Di ieri', 'htr')}
                        </div>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Documenti Valutati', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue(['totalDocumentsEvaluated'], 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <div className="meta">
                            <BadgeClassic label={getStatValue(['dailyAverageDocumentsEvaluated'], 0)} value={getStatValue(['dailyAverageDocumentsEvaluated'], 0)}/>
                            {__('Media giornaliera', 'htr')}
                        </div>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Tempo medio valutazione', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue(['averageEvaluationTimeDays'], 0)}
                            format={{ notation: 'compact' }}
                            suffix={` ${__('giorni', 'htr')}`}
                            locales="it-IT"/></span>
                    </div>
                </div>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>{__('Coda di lavoro', 'htr')}</h2>
                <ListCompaniesTablePreInstructor statuses={['ASSIGNED']}/>
            </div>

            <div className="appPage__spacer"></div>

            {/*<div className="appPageSection__hr">
                <span>{__('Azioni rapide', 'htr')}</span>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <div className="appPageSection__actions">
                    <Button
                        onClick={goToAllEvaluations}
                        label={__('Tutte le domande', 'htr')} icon="pi pi-arrow-right" iconPos="right"/>
                </div>
            </div>*/}
        </div>
    )
}

export default DashboardPreInstructor;